export default __webpack_public_path__ + "static/real2-d1016507d19e9ebbec7c18515d2aea23.png";